/* Global imports. */
import React from "react";
import headerLogo from "@images/header--logo.svg";

class HeaderLogo extends React.Component {
 
  render() {
    return (
      <img src={headerLogo} alt="" className="header-logo" />
    )
  }
}

export default HeaderLogo
